import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const CheckoutProjectCardSkeleton = () => {
  return (
    <Card className="bg-bg-secondary w-full rounded-sm">
      <CardContent className="flex flex-col items-center space-y-3 p-3">
        <div className="relative max-h-45 w-full h-full aspect-square">
          <Skeleton className="w-full h-full rounded-sm" />
        </div>
        <Skeleton className="h-4 w-24" />
      </CardContent>
    </Card>
  );
};
